import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-speedmap.svg";
import * as styles from "./Icon.module.scss";

type SpeedMapProps = React.SVGProps<SVGSVGElement>;

export const SpeedMap = ({ className, ...props }: SpeedMapProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
